import type { JSX } from 'react';

import classNames from 'classnames';

import styles from './Spinners.module.css';

interface SpinnersProps {
  className?: string;
}

export default function Spinners({ className }: SpinnersProps): JSX.Element {
  return (
    <span
      className={classNames(styles.SpinnersContainer, className)}
      data-testid="loading-spinners"
    >
      <span className={styles.SpinnerItem} />
      <span className={styles.SpinnerItem} />
      <span className={styles.SpinnerItem} />
    </span>
  );
}
